import { environment } from '../../environments/environment';
import { HttpClient, HttpErrorResponse, HttpHeaders} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})

export class HttpServiceMdr {

    constructor(private http: HttpClient, private router: Router,) {
 
    }
    baseUrl = environment.baseUrl;
    datesFromSummeryPage:any = {}
    
    postRequestCall(path: any, body:any, token:any, params: any){
        if(token != null){
          params.headers = new HttpHeaders({"Authorization": `Bearer ${token}`})
        }
        return this.http.post(this.baseUrl + path, body,  params).pipe(
          catchError((error: HttpErrorResponse) => {
            if(error.status === 401)
            {
              localStorage.clear();
              this.router.navigate(['/login'])
            }
            console.error('An error occurred:', error.error)
            return throwError(error)
          })
        )
        
      }

      putRequestCall(path: any, body:any,token:any, params: any){
        if(token != null){
            params.headers = new HttpHeaders({"Authorization": `Bearer ${token}`})
         }
        return this.http.put(this.baseUrl + path, body,  params).pipe(
          catchError((error: HttpErrorResponse) => {
            if(error.status === 401)
            {
              localStorage.clear();
              this.router.navigate(['/login'])
            }
            console.error('An error occurred:', error.error)
            return throwError(error)
          })
        )
      }

      patchRequestCall(path: any, body:any,token:any, params: any){
        if(token != null){
            params.headers = new HttpHeaders({
                "Authorization": `Bearer ${token}`, 
                "Content-Type": "application/json-patch+json"
              })
         }
        return this.http.patch(this.baseUrl + path, body,  params).pipe(
          catchError((error: HttpErrorResponse) => {
            if(error.status === 401)
            {
              localStorage.clear();
              this.router.navigate(['/login'])
            }
            console.error('An error occurred:', error.error)
            return throwError(error)
          })
        )
      }

      getRequestCall(path: any,token:any, params: any): Observable<any>{
      if(token != null){
      params.headers = new HttpHeaders({
        "Authorization": `Bearer ${token}`,
        "Cache-Control": "no-cache"
      })
      }
      return this.http.get(this.baseUrl + path, params).pipe(
        catchError((error: HttpErrorResponse) => {
          if(error.status === 401)
          {
            localStorage.clear();
            this.router.navigate(['/login'])
          }
          console.error('An error occurred:', error.error)
          return throwError(error)
        })
      )
    }

    getRequestCallByUrl(path: any,token:any, params: any): Observable<any>{
      if(token != null){
      params.headers = new HttpHeaders({
        "Authorization": `Bearer ${token}`,
        "Cache-Control": "no-cache"
      })
      }
      return this.http.get(path, params).pipe(
        catchError((error: HttpErrorResponse) => {
          if(error.status === 401)
          {
            localStorage.clear();
            this.router.navigate(['/login'])
          }
          console.error('An error occurred:', error.error)
          return throwError(error)
        })
      )
    }

    deleteRequestCall(path: any,body:any,token:any, params: any):  Observable<any>{
      if(token != null){
      params.headers = new HttpHeaders({"Authorization": `Bearer ${token}`})
      }
      return this.http.delete(this.baseUrl + path, params).pipe(
        catchError((error: HttpErrorResponse) => {
          if(error.status === 401)
          {
            localStorage.clear();
            this.router.navigate(['/login'])
          }
          console.error('An error occurred:', error.error)
          return throwError(error)
        })
      )
    }

  }